import { PropertyAsset } from '../types';
import { formatCurrency } from '../../../helpers/functions';
import React from 'react';
import InfoTooltip from '../../InfoTooltip/Info-tooltip';
import { useTranslation } from 'react-i18next';

function PropertyInfo({ addressData }: { addressData: PropertyAsset | null }) {
  const { t } = useTranslation();

  if (!addressData) return null;
  const {
    address,
    city,
    houseNumber,
    state,
    streetName,
    zestimate,
    zillowUrl,
  } = addressData;
  return (
    <>
      <div className="bg-grey-5 dark:bg-grey-80 w-full rounded-xl py-3 px-4 my-8 flex flex-col">
        <div className="flex gap-2 items-center">
          <span>Estimated value by</span>
          <img className="w-15" src="/zillow.svg" alt="zillow logo" />
          <InfoTooltip
            content={t('strategies.addProperty.tooltip')}
            isTooltipIconVisible
          />
        </div>
        <div className="flex justify-between mt-2">
          <div>
            <p className="text-base font-medium">
              {houseNumber} {streetName}
            </p>
            <span className="text-grey-50 text-sm truncate">
              {city}, {state}
            </span>
          </div>
          <p className="text-base font-medium">
            {formatCurrency(parseFloat(zestimate))}
          </p>
        </div>
        <a
          href={zillowUrl}
          target="_blank"
          rel="noreferrer"
          className="text-grey-50 text-xxs mt-2"
          style={{ textDecoration: 'underline' }}
        >
          See more details for “{address}” on Zillow
        </a>
      </div>
    </>
  );
}

export default React.memo(PropertyInfo);
